import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPricePlans } from 'services/pricePlan';

export const ThunkGetPricePlans = createAsyncThunk('pricePlan/getPricePlans', () =>
  getPricePlans().then(res => res.data),
);
